import './font-face.css';
import './typography.css';

export default {};
